// import {isLoggedIn} from '../../utils/auth'
import {injectReducer} from "../../store/reducers";

export default (store) => ({
  path: 'loyalty-summary',
  // onEnter: isLoggedIn(store), //TODO: enable it at the end
  /*  Async getComponent is only invoked when route matches   */
  getComponent(nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const LoyaltySummary = require('./containers/LoyaltySummary').default
      const {loadBrandNamesReducer, loadStoreOptionsReducer, loadStoreTagOptionsReducer} = require('../SalesAnalytics/modules/salesAnalytics')
      const {loadLoyaltySummaryReportReducer} = require('./modules/LoyaltySummaryReducer')
      const {filterValuesReducer} = require("../Home/modules/home");
      injectReducer(store, {key: 'filter', reducer: filterValuesReducer});
      injectReducer(store, {key: 'brands', reducer: loadBrandNamesReducer})
      injectReducer(store, {key: 'storeOptions', reducer: loadStoreOptionsReducer})
      injectReducer(store, {key: 'reportData', reducer: loadLoyaltySummaryReportReducer})
      injectReducer(store, {key: 'storeTagOptions', reducer: loadStoreTagOptionsReducer})

      cb(null, LoyaltySummary)
      /* Webpack named bundle   */
    }, 'loyaltySummary')
  }
})



// WEBPACK FOOTER //
// ./src/routes/LoyaltySummary/index.js